/** Pamatuje si poslední listing URL + scroll pozici, aby návrat z detailu
 *  obnovil filtry, stránku i pozici scrolu. */

const URL_KEY = 'tiskstrihu_last_list_url';

export function saveListReturnState(): void {
  try {
    const url = window.location.pathname + window.location.search + window.location.hash;
    sessionStorage.setItem(URL_KEY, url);
    // scroll position uložíme do stávající struktury, kterou už Products.tsx používá
    const scrollPositions = JSON.parse(sessionStorage.getItem('scrollPositions') || '{}');
    scrollPositions['main'] = window.scrollY;
    sessionStorage.setItem('scrollPositions', JSON.stringify(scrollPositions));
  } catch {}
}

export function getListReturnUrl(): string {
  try {
    const url = sessionStorage.getItem(URL_KEY);
    if (url && url.startsWith('/product')) return url;
  } catch {}
  return '/product';
}

export function clearListReturnState(): void {
  try {
    sessionStorage.removeItem(URL_KEY);
    const scrollPositions = JSON.parse(sessionStorage.getItem('scrollPositions') || '{}');
    delete scrollPositions['main'];
    sessionStorage.setItem('scrollPositions', JSON.stringify(scrollPositions));
  } catch {}
}
